import { FC, PropsWithChildren } from "react";
export function withProviders(Container: FC<PropsWithChildren>) {
  return function (...Providers: FC<PropsWithChildren>[]) {
    return Providers.reduce(providerReducer, Container);
  };
}
function providerReducer(ChildProvider: FC<PropsWithChildren>, ParentProvider: FC<PropsWithChildren>) {
  return ({
    children
  }: PropsWithChildren) => <ParentProvider>
      <ChildProvider>{children}</ChildProvider>
    </ParentProvider>;
}